/**
 * NL类库
 *
 * @module nllib
 */

/**
 * 是否null或者undefined
 *
 * @class nllib/src/common/is_null_or_undefined
 * @static
 *
 * @param {object} pValue 要进行判断的值
 * @return {boolean} 是否null或者undefined
 *
 * @demo src/common/is_null_or_undefined/demo/index.demo.js
 */

const is_null_or_undefined = function (pValue) {
    return pValue === null || pValue === undefined;
};

module.exports = is_null_or_undefined;
